<template>
  <div class="cobrancas-e-boletos">
    <div
      class="card shadow-sm mb-3"
      aria-label="Visão de cobranças"
    >
      <div class="card-body py-2">
        <div
          class="nav nav-pills cobrancas-view-tabs"
          role="tablist"
          aria-label="Escolha a visão de cobranças"
        >
          <button
            type="button"
            class="nav-link"
            :class="{ active: visao === 'cobrancas' }"
            role="tab"
            :aria-selected="visao === 'cobrancas'"
            @click="selecionarVisao('cobrancas')"
          >
            <i class="bi bi-receipt me-1"></i>
            Cobranças individuais
          </button>

          <button
            type="button"
            class="nav-link"
            :class="{ active: visao === 'lotes' }"
            role="tab"
            :aria-selected="visao === 'lotes'"
            @click="selecionarVisao('lotes')"
          >
            <i class="bi bi-collection me-1"></i>
            Lotes de cobranças
          </button>

          <button
            type="button"
            class="nav-link"
            :class="{ active: visao === 'monitoramento' }"
            role="tab"
            :aria-selected="visao === 'monitoramento'"
            @click="selecionarVisao('monitoramento')"
          >
            <i class="bi bi-activity me-1"></i>
            Monitoramento
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="visao === 'cobrancas'"
      role="tabpanel"
      aria-label="Cobranças individuais"
    >
      <ListarCobrancas />
    </div>

    <div
      v-else-if="visao === 'lotes'"
      role="tabpanel"
      aria-label="Lotes de cobranças"
    >
      <ListarLotesCobrancas />
    </div>

    <div
      v-else
      role="tabpanel"
      aria-label="Monitoramento operacional"
    >
      <MonitoramentoCobrancasJobs />
    </div>
  </div>
</template>

<script setup>
import {
  ref
} from 'vue';

import ListarCobrancas
  from '@/components/Financeiro/Cobrancas/ListarCobrancas.vue';

import ListarLotesCobrancas
  from '@/components/Financeiro/Cobrancas/ListarLotesCobrancas.vue';

import MonitoramentoCobrancasJobs
  from '@/components/Financeiro/Cobrancas/MonitoramentoCobrancasJobs.vue';

const visao =
  ref(
    'cobrancas'
  );

function selecionarVisao(
  value
) {
  if (
    value !== 'cobrancas' &&
    value !== 'lotes' &&
    value !== 'monitoramento'
  ) {
    return;
  }

  visao.value =
    value;
}
</script>

<style scoped>
.cobrancas-e-boletos {
  min-width: 0;
}

.cobrancas-view-tabs {
  gap: 0.35rem;
}

.cobrancas-view-tabs .nav-link {
  border: 1px solid transparent;
  font-size: 0.85rem;
  font-weight: 600;
}

.cobrancas-view-tabs .nav-link:not(.active) {
  color: #495057;
  border-color: #dee2e6;
  background: #fff;
}

@media (max-width: 575.98px) {
  .cobrancas-view-tabs {
    display: grid;
    grid-template-columns: 1fr;
  }

  .cobrancas-view-tabs .nav-link {
    width: 100%;
  }
}
</style>
